<template>
  <div class="ew-pubnav">
    <b-navbar toggleable="md" class="ew-pubnav__inner">
      <b-navbar-brand to="/" class="ew-pubnav__brand">
        <img class="ew-pubnav__logo" src="@/assets/images/logo-ew.png" alt="Logo Moovet">
      </b-navbar-brand>

      <b-navbar-toggle target="ew-pubnav-collapse" class="ew-pubnav__toggle"></b-navbar-toggle>

      <b-collapse is-nav id="ew-pubnav-collapse">
        <b-navbar-nav class="ml-auto ew-pubnav__actions">
          <router-link class="ew-pubnav__link" to="/preguntas-frecuentes">Preguntas frecuentes</router-link>
          <router-link class="ew-pubnav__link" to="/contactanos">Contacto</router-link>
          <router-link v-if="isLoging" class="ew-btn-primary ew-pubnav__cta" to="/dashboard">Ir al panel</router-link>
          <template v-else>
            <router-link class="ew-pubnav__link" to="/signin">Iniciar sesión</router-link>
            <router-link class="ew-btn-primary ew-pubnav__cta" to="/signup">Crear cuenta</router-link>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'NavbarPublic',
  data () {
    return {
      isLoging: false
    }
  },
  created () {
    this.isLoging = !!localStorage.getItem('ew-user-id')
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-pubnav { @include app-tokens; }
.ew-btn-primary { @include ew-btn-primary; }

.ew-pubnav__inner {
  padding: 0 2rem;
  height: 4.5rem;
  background: var(--app-canvas);
  border-bottom: 1px solid var(--app-border);
}

.ew-pubnav__brand { padding: 0; margin: 0; }
.ew-pubnav__logo { height: 2.1rem; width: auto; }

.ew-pubnav__toggle {
  border: none;
  color: var(--app-navy);
}

.ew-pubnav__actions {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.ew-pubnav__link {
  font-family: var(--app-font);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--app-navy-secondary);

  &:hover { color: var(--app-navy); text-decoration: none; }
  &:focus-visible {
    outline: 3px solid var(--app-accent);
    outline-offset: 3px;
  }
}

.ew-pubnav__cta {
  height: 2.5rem;
  padding: 0 1.25rem;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

@media (max-width: 767px) {
  .ew-pubnav__inner { padding: 0 1rem; }
  .ew-pubnav__actions { gap: 0.5rem; padding: 1rem 0; align-items: flex-start; }
  .ew-pubnav__cta { margin-top: 0.5rem; }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/NavbarPublic.vue